import { ajaxError } from '../ui/feedback.js';

export function initAccountSearch() {
    var timeout;

    $(document).on('change keyup paste input', '.account-search', function () {
        var $self = $(this);
        var $button = $self.closest('form').find('.js-btn-account');
        var $validator = $self.closest('.js-nav-account-wrap').find('.js-account-validation');

        if ($self.val().length == 0) {
            $self.removeClass('text-danger text-success');
            $button.addClass('disabled');
            $validator.empty();
        }

        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }

        timeout = setTimeout(function () {
            if ($self.val().length >= 2) {
                $.ajax({
                    error: ajaxError('Could not check that account number.'),
                    url: 'account/ajaxValidateAccountNumber',
                    type: 'post',
                    data: {
                        account: $self.val(),
                    },
                    dataType: 'json',
                    success: function (validatedAccount) {
                        if (validatedAccount === false) {
                            $button
                                .addClass('disabled')
                                .attr('disabled', 'disabled');
                            $validator
                                .removeClass('text-success')
                                .addClass('text-danger')
                                .html(
                                    '<i class="fa fa-exclamation-triangle" title="Account Not Found"></i>'
                                );
                            $self
                                .removeClass('text-success')
                                .addClass('text-danger');
                        } else {
                            $button
                                .removeClass('disabled')
                                .removeAttr('disabled');
                            $validator
                                .removeClass('text-danger')
                                .addClass('text-success')
                                .html(
                                    '<i class="fa fa-check" title="Valid Account"></i>'
                                );
                            $self
                                .removeClass('text-danger')
                                .addClass('text-success');
                        }
                    },
                });
            }
        }, 300);
    });
}
